import { Link } from 'react-router-dom';

export default function TermsOfUsePage() {
  return (
    <main className="min-h-screen bg-white">
      <section className="bg-donnos-dark px-4 py-8 text-white md:px-8 lg:px-12">
        <Link to="/" className="inline-flex h-12 w-[178px] overflow-hidden rounded-md border border-white/15 bg-black/35">
          <img src="/assets/donnos-logo.png" alt="Donnos" className="h-full w-full object-contain" />
        </Link>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:px-8">
        <p className="mb-2 text-sm font-extrabold uppercase tracking-wide text-donnos-green">Donnos</p>
        <h1 className="mb-6 text-3xl font-extrabold text-gray-950">Termos de Uso</h1>
        <div className="space-y-5 text-sm leading-relaxed text-slate-600">
          <p>
            Ao acessar este site, o usuário concorda com estes Termos de Uso e com a utilização responsável das informações, formulários e recursos disponibilizados pela Donnos.
          </p>
          <p>
            Os conteúdos do site têm finalidade institucional e comercial. Informações sobre produtos, atas, disponibilidade, marcas, preços ou condições podem ser alteradas sem aviso prévio.
          </p>
          <p>
            Solicitações enviadas pelo site não representam contratação automática. Propostas, orçamentos e condições comerciais dependem de confirmação formal da equipe Donnos.
          </p>
          <p>
            É proibido usar o site para fins ilícitos, envio de dados falsos, tentativa de acesso indevido, reprodução não autorizada de conteúdo ou qualquer prática que prejudique a operação da plataforma.
          </p>
          <p>
            Marcas, logotipos e imagens apresentados pertencem aos seus respectivos titulares e são utilizados para identificação institucional, comercial ou de relacionamento.
          </p>
          <p>
            Dúvidas sobre estes termos podem ser enviadas para contato@donnosvendas.com.
          </p>
        </div>

        <Link to="/" className="mt-8 inline-flex rounded-md bg-donnos-green px-5 py-3 text-sm font-bold text-white hover:bg-donnos-green-dark">
          Voltar ao site
        </Link>
      </section>
    </main>
  );
}
